<template>
  <CustomMarker :options="options">
    <div class="flex-center h-[22px] w-[22px] shadow-popper bg-white rounded-full">
      <div
        class="h-3.5 w-3.5 rounded-full"
        :class="ColorMap.get(shipment.status)"
      />
    </div>
  </CustomMarker>
</template>

<script setup lang="ts">
import { CustomMarker } from 'vue3-google-map'
import type { Shipment } from '@/types'

export interface Props {
  // eslint-disable-next-line no-undef
  options: google.maps.CustomMarkerOptions
  shipment: Shipment
}

const ColorMap: Map<Shipment['status'], string> = new Map([
  [ 'unknown', 'bg-blue-400' ],
  [ 'pre_transit', 'bg-blue-400' ],
  [ 'in_transit', 'bg-blue-400' ],
  [ 'out_for_delivery', 'bg-blue-400' ],
  [ 'delivered', 'bg-green-400' ],
  [ 'available_for_pickup', 'bg-blue-400' ],
  [ 'return_to_sender', 'bg-red-400' ],
  [ 'failure', 'bg-red-400' ],
  [ 'cancelled', 'bg-red-400' ],
  [ 'error', 'bg-red-400' ]
])

defineProps<Props>()
</script>
